import { bindFieldCleanup, bindPasswordToggles } from "./components.js";
import { config } from "./config.js";
import { initAppLogin } from "./app-login.js";
import { initForgotPassword } from "./forgot-password.js";
import { initLogin } from "./login.js";
import { initPreferences } from "./preferences.js";
import { initResetPassword } from "./reset-password.js";
import { initSignup } from "./signup.js";
import { initVerification } from "./verify-login.js";

initPreferences();
bindFieldCleanup();
bindPasswordToggles();
if (config.page === "login") initAppLogin();

(
	({
		login: initLogin,
		signup: initSignup,
		forgot: initForgotPassword,
		reset: initResetPassword,
		verify: initVerification,
	})[config.page] || (() => {})
)();
